/**
 * @generated SignedSource<<92e906826477423a1fa87b5612ba3254>>
 * @relayHash 0b456e44a9397ce7756e643321eb4681
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d442b64928804cd27a695f19c4594036a888f67dbe22d5764db67e3820c7402

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "%future added value";
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type JiraJqlScopeInput = {
  board?: JiraJqlBoardInput | null | undefined;
  plan?: JiraJqlPlanInput | null | undefined;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null | undefined;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null | undefined;
};
export type hydrationRelayJqlBuilderAdvancedQuery$variables = {
  cloudId: string;
  jql: string;
  scope?: JiraJqlScopeInput | null | undefined;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type hydrationRelayJqlBuilderAdvancedQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery: {
        readonly fields?: ReadonlyArray<{
          readonly field?: {
            readonly jqlTerm: string;
            readonly searchTemplate: {
              readonly key: string | null | undefined;
            } | null | undefined;
          };
          readonly values?: ReadonlyArray<{
            readonly values?: ReadonlyArray<{
              readonly __typename: string;
              readonly displayName: string;
              readonly jqlTerm: string;
              readonly user?: {
                readonly picture: AGG$URL;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined>;
        }>;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type hydrationRelayJqlBuilderAdvancedQuery = {
  response: hydrationRelayJqlBuilderAdvancedQuery$data;
  variables: hydrationRelayJqlBuilderAdvancedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "jql"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  },
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v7 = {
  "concreteType": "JiraJqlField",
  "kind": "LinkedField",
  "name": "field",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "concreteType": "JiraJqlSearchTemplate",
      "kind": "LinkedField",
      "name": "searchTemplate",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        }
      ]
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hydrationRelayJqlBuilderAdvancedQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "hydrateJqlQuery",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v10/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlUserFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraJqlQueryHydratedValue"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlHydratedQuery"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hydrationRelayJqlBuilderAdvancedQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "hydrateJqlQuery",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v9/*: any*/),
                                                  (v10/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraJqlUserFieldValue"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraJqlQueryHydratedValue"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlHydratedQuery"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5d442b64928804cd27a695f19c4594036a888f67dbe22d5764db67e3820c7402",
    "metadata": {},
    "name": "hydrationRelayJqlBuilderAdvancedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "73acc033ad6fdea5f965fc59c156d626";

export default node;
